import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { CMDSpInitGift, ICommand } from '../../live';
import { AbstractHandler } from '../AbstractHandler';
import { giftSliceActions } from '@/modules/main/slice/gift';

export class CMDSpInitGiftHandler extends AbstractHandler {
    _command: CMDSpInitGift;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDSpInitGift;
    }

    handle(dispatch: Dispatch<AnyAction>): void {
        const cmd = this._command;
        dispatch(
            giftSliceActions.updateData({
                accountType: cmd.AccountType,
                currencyGiftEnable: cmd.CurrencyGiftEnable ? true : false,
                lobbyGiftEnable: cmd.LobbyGiftEnable ? true : false,
                giftList: cmd.giftList,
            })
        );
    }
}
